import React, { useState, useEffect } from 'react';
import { reportService } from '../../services/api';

function ReportsManagement() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    try {
      const data = await reportService.dashboard();
      setDashboard(data);
    } catch (error) {
      console.error('Error loading reports:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  const stats = dashboard || {};

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Reports & Analytics</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow border border-slate-200">
          <div className="text-sm text-gray-700 font-semibold">Total Orders</div>
          <div className="text-2xl font-bold text-black">{stats.total_orders || 0}</div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow border border-slate-200">
          <div className="text-sm text-gray-700 font-semibold">Total Revenue</div>
          <div className="text-2xl font-bold text-black">${stats.total_revenue || 0}</div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow border border-slate-200">
          <div className="text-sm text-gray-700 font-semibold">Total Users</div>
          <div className="text-2xl font-bold text-black">{stats.total_users || 0}</div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow border border-slate-200">
          <div className="text-sm text-gray-700 font-semibold">Total Products</div>
          <div className="text-2xl font-bold text-black">{stats.total_products || 0}</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow border border-slate-200">
          <h3 className="text-lg font-bold mb-4 text-black">Top Selling Products</h3>
          <ul className="space-y-2">
            {(stats.top_products || []).map((product) => (
              <li key={product.id} className="flex justify-between text-sm text-gray-800 border-b border-slate-100 pb-2">
                <span className="font-medium">{product.name}</span>
                <span className="font-bold text-black">{product.sales_count || 0} sold</span>
              </li>
            ))}
            {(stats.top_products || []).length === 0 && <p className="text-gray-600 text-sm italic">No data yet</p>}
          </ul>
        </div>
        <div className="bg-white p-6 rounded-lg shadow border border-slate-200">
          <h3 className="text-lg font-bold mb-4 text-black">Recent Orders</h3>
          <ul className="space-y-2">
            {(stats.recent_orders || []).map((order) => (
              <li key={order.id} className="flex justify-between text-sm text-gray-800 border-b border-slate-100 pb-2">
                <span className="font-medium">{order.order_number}</span>
                <span className="font-bold text-black">₹{order.total}</span>
              </li>
            ))}
            {(stats.recent_orders || []).length === 0 && <p className="text-gray-600 text-sm italic">No data yet</p>}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ReportsManagement;
